import { Modal, ScrollArea } from '@mantine/core';
import { FAQContent } from './FAQContent';

interface FAQPopupProps {
  opened: boolean;
  onClose: () => void;
}

export function FAQPopup({ opened, onClose }: FAQPopupProps) {
  return (
    <Modal opened={opened} onClose={onClose} title="Frequently Asked Questions" size="xl" centered>
      <ScrollArea h={600}>
        <FAQContent />
      </ScrollArea>
    </Modal>
  );
}
